"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FacebookMessengerButton = exports.facebookMessengerShareAction = void 0;

var _icons = require("../../assets/icons");

var _sharing_helper = require("../../helpers/sharing_helper");

var _base = require("./base");

var facebookMessengerShareAction = function facebookMessengerShareAction(_ref) {
  var facebookAppId = _ref.facebookAppId,
      shareUrl = _ref.shareUrl,
      utmParams = _ref.utmParams;
  return (0, _sharing_helper.isMobileOrTablet)() ? window.open("fb-messenger://share?link=".concat((0, _sharing_helper.encodedShareURL)(shareUrl, utmParams), "&app_id=").concat(facebookAppId)) : (0, _sharing_helper.openPopup)("http://www.facebook.com/dialog/send?app_id=".concat(facebookAppId, "&link=").concat((0, _sharing_helper.encodedShareURL)(shareUrl, utmParams), "&redirect_uri=").concat(encodeURIComponent(shareUrl)));
};

exports.facebookMessengerShareAction = facebookMessengerShareAction;
var FacebookMessengerButton = (0, _base.buildShareButtonComponent)({
  action: facebookMessengerShareAction,
  ariaLabel: 'Facebook Messenger',
  buttonLabel: 'Messenger',
  className: 'share-button--facebook-messenger',
  icon: _icons.FacebookMessengerIcon
});
exports.FacebookMessengerButton = FacebookMessengerButton;